<template>
  <div>
    <v-layout class="p-4 pr-0 border-bottom-light-grey min-height-57px">
      <v-flex class="d-flex font-level-3-bold my-auto">
        <span class="detail-svg-icon mr-2">
          <!--begin::Svg Icon-->
          <!--  <v-icon color="blue darken-4">mdi-cart</v-icon> -->
          <span class="svg-icon svg-icon-lg mr-2 svg-v-list-icon">
            <!--end::Svg Icon-->
          </span>
        </span>
        <span class="form-title font-size-20 font-weight-600"
          >Funding Organisation</span
        >
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        @click="saveFunding = true"
        color="cyan white--text"
        dense
        tile
        >Manage Funding Organisation</v-btn
      >
    </v-layout>

    <div
      class="overflow-y"
      style="max-height: calc(100vh - 306px)"
      v-if="!pageLoading"
    >
      <template v-if="organisationList.length">
        <table width="100%" class="detail-table table-head-sticky">
          <thead>
            <tr style="background-color: #f3f6f9; color: #24326d">
              <th
                width="50"
                class="py-1 font-size-13 text-uppercase font-weight-500"
              >
                #
              </th>

              <th class="py-1 font-size-13 text-uppercase font-weight-500">
                Funding Organisation
              </th>

               <th class="py-1 font-size-13 text-uppercase font-weight-500">
                Copayment Amount
              </th>

              <th class="py-1 font-size-13 text-uppercase font-weight-500">
                Start Date
              </th>
              <th class="py-1 font-size-13 text-uppercase font-weight-500">
                End Date
              </th>

              <th class="py-1 font-size-13 text-uppercase font-weight-500">
                Actual Start Date
              </th>

              <th class="py-1 font-size-13 text-uppercase font-weight-500">
                Contract Type
              </th>
              <th class="py-1 font-size-13 text-uppercase font-weight-500">
                Contract Status
              </th>

              <th class="py-1 font-size-13 text-uppercase font-weight-500">
                Expiry Alert
              </th>

            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in organisationList"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
            >
              <template v-if="row?.id" >
                <td class="p-2 border-top-light-grey ">
                  {{ index + 1 }}
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.funding_organisation">
                    {{ row.funding_organisation }}
                  </template>
                  <em v-else class="text-muted">no funding organisation</em>
                </td>

               <td class="p-2 border-top-light-grey">

                  <template v-if="row.copayment_amount > 0">
                    {{ row.copayment_amount_type == 1 ? '$ ' + row.copayment_amount : row.copayment_amount + ' %' }}
                  </template>
                  <em v-else class="text-muted">no copayment amount</em>

                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.contract_start_date">
                    {{ formatDate(row.contract_start_date) }}
                  </template>
                  <em v-else class="text-muted">no start date</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.contract_end_date">
                    {{ formatDate(row.contract_end_date) }}
                  </template>
                  <em v-else class="text-muted">no end date</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.actual_start_date">
                    {{ formatDate(row.actual_start_date) }}
                  </template>
                  <em v-else class="text-muted">no actual start date</em>
                </td>


                <td class="p-2 border-top-light-grey">
                  <template v-if="row.contract_type">
                    {{ row.contract_type }}
                  </template>
                  <em v-else class="text-muted">no contract type</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.contract_status">
                    <v-chip
                              small
                              color="blue white--text"
                              label
                              class="ml-2"
                              style="padding:10px;"
                              v-if="row.contract_status === 'Upcoming'"
                            >
                              <span class="font-size-16 font-weight-500">
                                Upcoming
                              </span>
                            </v-chip>

                            <v-chip
                              small
                              color="red white--text"
                              label
                              class="ml-2"
                              style="padding:10px;"
                              v-else-if="row.contract_status === 'Expired'"
                            >
                              <span class="font-size-16 font-weight-500">
                                Expired
                              </span>
                            </v-chip>

                             <v-chip
                                small
                                color="green white--text"
                                label
                                class="ml-2"
                                style="padding:10px;"
                                v-else
                              >
                                <span class="font-size-16 font-weight-500 text-capitalize">
                                  {{ row.contract_status}}
                                </span>
                              </v-chip>

                  </template>
                  <em v-else class="text-muted">no contract status</em>
                </td>

                 <td class="p-2 border-top-light-grey">
                   <v-chip
                      v-if="isExpiring(row.contract_end_date) && row.contract_status !== 'Expired'"
                      small
                      color="orange white--text"
                      label
                      class="ml-2"
                      style="padding:10px;"
                     
                  >
                    <span class="font-size-16 font-weight-500">
                      Expiring
                    </span>
                 </v-chip>
                 <span v-else-if="row.contract_status !== 'Expired'">-</span>
                 
                </td>

              </template>
            </tr>
          </tbody>
        </table>
      </template>
      <p v-else class="m-0 row-not-found text-center">
        <img
          width="40px"
          :src="$assetURL('media/error/empty.png')"
          class="row-not-found-image"
        />
        Uhh... There are no funding organisation at the moment.
      </p>
    </div>
    <div v-else class="mx-20 my-40 text-center">
      <v-progress-linear
        color="orange darken-2"
        indeterminate
        height="6"
      ></v-progress-linear>
    </div>
    <Dialog :dialog="saveFunding" :dialog-width="1400" dense>
      <template v-slot:title>
        <v-layout>
          <span>Funding Organisation</span>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text mr-2"
            depressed
            color="cyan"
            tile
            :disabled="isDisable"
            @click="addFunding()"
          >
            <v-icon left>mdi-plus</v-icon>
            Add Funding Organisation
          </v-btn>
        </v-layout>
      </template>
      <template v-slot:body>
        <div class="px-4 pt-4 pb-3">
          <v-form
            ref="fundingForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="saveFundingOrganisation"
          >
            <table width="100%" class="detail-table table-head-sticky">
              <thead>
                <tr style="background-color: #f3f6f9; color: #24326d">
                  <th class="py-1 font-size-13 text-uppercase font-weight-500">
                    Funding Organisation
                  </th>

                  <th class="py-1 font-size-13 text-uppercase font-weight-500">
                    Copayment Amount
                  </th>

                  <th class="py-1 font-size-13 text-uppercase font-weight-500">
                    Start Date
                  </th>
                  <th class="py-1 font-size-13 text-uppercase font-weight-500">
                    End Date
                  </th>

                  <th class="py-1 font-size-13 text-uppercase font-weight-500">
                    Actual Start Date
                  </th>

                  <th class="py-1 font-size-13 text-uppercase font-weight-500">
                    Contract Type
                  </th>
                  <th
                    class="py-1 font-size-13 text-uppercase font-weight-500"
                    colspan="2"
                  >
                    Contract Status
                  </th>

                  

                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in organisationList"
                  :key="index"
                  :class="{
                    'custom-border-top': index == 0,
                    'orange_lighten-5': index % 2 == 0,
                  }"
                >
                
                  <td class="p-2 border-top-light-grey required">
                    <v-autocomplete
                      :items="fundingOrganisations"
                      dense.
                      filled
                      color="cyan"
                      item-color="cyan"
                      solo
                      flat
                      v-model="row.funding_group_id"
                      placeholder="Funding Organisation"
                      item-text="text"
                      item-value="id"
                      class="width-100 new-height"
                      :error="!row.funding_group_id"
                      hide-details
                      :rules="[
                        validateRules.required(
                          row.funding_group_id,
                          'Funding Organisation'
                        ),
                      ]"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="'No Funding Organisation(s) Found.'"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </td>

                   <td class="p-2 border-top-light-grey">
                     <div class="d-flex" style="gap: 0; margin: 0; padding: 0;">
                     
                        <v-select
                            style="flex: 0 0 30%;"
                            :items="copaymentTypeList"
                            v-model="row.copayment_amount_type"
                            @change="handleCopaymentAmount(row)"
                            hide-detailss
                            item-text="type"
                            item-value="value"
                            item-color="cyan"
                            class="line-item-header-text discount-type text-h6 px-0"
                            placeholder="Type"
                            dense
                            filled
                            solo
                            flat
                            color="cyan"
                        />

                        <v-text-field
                          style="flex: 0 0 70%;"
                          dense
                          color="cyan"
                          filled
                          type="number"
                          v-on:keypress="limitDecimal($event, row.copayment_amount)"
                          v-model="row.copayment_amount"
                          v-model.trim.number.lazy="row.copayment_amount"
                          :rules="[
                            validateRules.maxLength(
                              row.copayment_amount,
                              'copayment amount',
                              12
                            ),
                          ]"
                          placeholder="Copayment Amount"
                          solo
                          flat
                          hide-details
                          @input="validateCopaymentAmount(row)"
                        >
                        </v-text-field>
                                 
                      </div>
                  </td>

                  
                  <td class="p-2 border-top-light-grey required">
                    <DatePicker
                      solo
                      flat
                      :mandatory="false"
                      :nullable="true"
                      placeholder="Start Date"
                      :showFormatSuffix="false"
                      v-model="row.contract_start_date"
                      :rules="[() => validateRules.required(row.contract_start_date, 'Contract Start Date')]"
                    ></DatePicker>
                  </td>

                  <td class="p-2 border-top-light-grey required">
                    <DatePicker
                      solo
                      flat
                      :mandatory="false"
                      :nullable="true"
                      :showFormatSuffix="false"
                      placeholder="End Date"
                      :rules="[() => validateRules.required(row.contract_end_date, 'Contract End Date')]"
                      v-model="row.contract_end_date"
                      @select= "() => handleContractEndDateChange(index)"
                      :min-date ="row.contract_start_date"
                    ></DatePicker>
                  </td>

                   <td class="p-2 border-top-light-grey">
                    <DatePicker
                      solo
                      flat
                      :mandatory="false"
                      :nullable="true"
                      :showFormatSuffix="false"
                      placeholder="Actual Start Date"
                      v-model="row.actual_start_date"
                      :min-date ="row.contract_start_date"
                      :max-date="row.contract_end_date"
                    ></DatePicker>
                  </td>


                  <td class="p-2 border-top-light-grey">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      solo
                      flat
                      hide-details
                      :disabled="pageLoading"
                      :loading="pageLoading"
                      id="contract type"
                      placeholder="Contract Type"
                      v-model="row.contract_type"
                      :rules="[
                            validateRules.maxLength(
                              row.contract_type,
                              'contract type',
                              50
                            ),
                      ]"
                    ></v-text-field>
                  </td>

                  <td class="p-2 border-top-light-grey">
                   <template v-if="row.contract_status">
                     <v-chip
                              small
                              color="blue white--text"
                              label
                              class="ml-2"
                              style="padding:10px;"
                              v-if="row.contract_status === 'Upcoming'"
                            >
                              <span class="font-size-16 font-weight-500">
                                Upcoming
                              </span>
                            </v-chip>

                            <v-chip
                              small
                              color="red white--text"
                              label
                              class="ml-2"
                              style="padding:10px;"
                              v-else-if="row.contract_status === 'Expired'"
                            >
                              <span class="font-size-16 font-weight-500">
                                Expired
                              </span>
                            </v-chip>

                             <v-chip
                                small
                                color="green white--text"
                                label
                                class="ml-2"
                                style="padding:10px;"
                                outlined
                                v-else
                              >
                                <span class="font-size-16 font-weight-500 text-capitalize">
                                  {{ row.contract_status}}
                                </span>
                              </v-chip>

                  </template>
                  <em v-else class="text-muted">no contract status</em>
                  </td>
                  <td class="p-2 border-top-light-grey">
                    <template v-if="row?.id > 0">
                      <v-btn
                        class="white--text"
                        depressed
                        color="red darken-4"
                        tile
                        @click="deleteDialogById(row)"
                        min-width="30"
                        max-width="30"
                        width="30"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                        class="white--text"
                        depressed
                        color="red darken-4"
                        tile
                        @click="openDeleteDialog(index, row)"
                        min-width="30"
                        max-width="30"
                        width="30"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-form>
        </div>
      </template>
      <template v-slot:action>
        <v-btn color="mr-2" tile depressed @click="closeDialog()">Close</v-btn>
        <v-btn
          color="cyan white--text"
          tile
          depressed
          :loading="pageLoading"
          :disabled="pageLoading || isDisable || !formValid || (organisationList && organisationList.length <= 0) "
          @click="saveFundingOrganisation()"
          >Save</v-btn
        >
      </template>
    </Dialog>

    <ManageContractStatus
      :d-dialog="manageContractStatus"
      :e_contract_status="contractStatuses"
      v-on:close-dialog="manageContractStatus = false"
      v-on:get-e-contract_status="getOptions"
    ></ManageContractStatus>

    <DeleteConfirmTemplate :delete-dialog="deleteConfirm">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-16 font-weight-500 delete-text">
          Once you delete
          <span class="font-weight-700"
            >{{ removeOrganisation?.funding_organisation }} Organisation</span
          >, you won't be able to retrieve this later.<br />Are you sure you
          want to delete
          <span class="font-weight-700"
            >{{ removeOrganisation?.funding_organisation }} Organisation</span
          >
          ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="deleteVisitLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteConfirm = false"
          >No! Cancel</v-btn
        >
        <v-btn
          v-if="removeOrganisation?.id"
          :disabled="deleteVisitLoading"
          :loading="deleteVisitLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteOrganisationById()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >

        <v-btn
          v-else
          :disabled="deleteVisitLoading"
          :loading="deleteVisitLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteOrganisation()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteConfirmTemplate>
  </div>
</template>
 
<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import moment from 'moment';

import { GET, DELETE } from "@/core/services/store/request.module";
import Dialog from "@/view/components/Dialog";

import DatePicker from "@/view/components/DatePicker";
import DeleteConfirmTemplate from "@/view/pages/partials/Delete";
import ManageContractStatus from "@/view/pages/partials/Manage-Contract-Status.vue";

import {
  ErrorEventBus,
  SuccessEventBus,
  InitializeError,
} from "@/core/lib/message.lib";

export default {
  name: "fundingOrganisationsListing",
  mixins: [CommonMixin, ValidationMixin],
  props: {
    typeText: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    typeUuid: {
      type: String,
      default: null,
    },
    organisationData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    productStatus: {
      type: Number,
      default: null,
    },
    customer: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      deleteVisitLoading: false,
      manageContractStatus: false,
      prices: [],
      formValid: true,
      organisationList: [],
      saveFunding: false,
      pageLoading: false,
      fundingOrganisations: [],
      contractStatuses: [],
      manageOrganisationDialog: false,
      deleteConfirm: false,
      removeIndex: null,
      removeOrganisation: null,
      showError : true,
      copaymentTypeList: [
        { type: "$", value: "1" },
        { type: "%", value: "2" },
      ],

    };
  },
  watch: {
    customer: {
      handler(customer) {
        if (customer) {
          this.getOrganisationList();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {

     validateCopaymentAmount(detail)
    {

        this.$nextTick(() => {

        let amount = parseFloat(detail.copayment_amount) || 0;

          if (detail.copayment_amount_type === 2 && amount >= 100) {
          
              detail.copayment_amount = 100.00;
         
          }

        });

    },

    handleCopaymentAmount(row)
    {
       row.copayment_amount = null;

    },


    contractStatus() {
      this.manageContractStatus = true;
    },

   isExpiring(endDate) {
    if (!endDate) return false;

    const today = moment().startOf('day');
    const contractEnd = moment(endDate).startOf('day');

    const diffDays = contractEnd.diff(today, 'days');
    return diffDays >= 0 && diffDays <= 7;
  },

    handleContractEndDateChange(index) {
        this.organisationList[index].contract_status = null;
        this.showEndDateError = false;
    },

    getOrganisationList() {
      this.$store
        .dispatch(GET, {
          url: `organisation-list/${this.customer}`,
        })
        .then((response) => {
             this.organisationList = (response?.data || []).map(org => ({
        ...org,
        funding_group_id: Number(org.funding_group_id), 
        
      }));
           
        })
        .catch(() => {
          this.goBack();
        })
        .finally(() => {
          //
        });
    },

    OrganisationData() {
      this.manageOrganisationDialog = true;
      this.getOptions();
    },

    saveFundingOrganisation() {
        const isValid = this.$refs["fundingForm"].validate();
        this.formValid = isValid;
      const formErrors = this.validateForm(this.$refs["fundingForm"]);
      if (!isValid || formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      this.pageLoading = true;
      ApiService.post(`customer/${this.customer}/funding-organisations`, {
        funding_organisations: this.organisationList,
      })
        .then(() => {
          SuccessEventBus.$emit(
            "update:success",
            "Success ! Funding Organisation Updated Successfully."
          );
          this.getOrganisationList();
          this.$emit("success", true);
          this.closeDialog();
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },

     isInvalidDate(date) {
      return !date || date === '';
    },

    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "customer/options" })
        .then(({ data }) => {
          _this.fundingOrganisations = data.funding_organisations;
          _this.contractStatuses = data.contract_statuses;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    discountPriceChange(index) {
      if (
        this.priceList[index].discount_price > this.priceList[index].sale_price
      ) {
        this.priceList[index].discount_price = this.priceList[index].sale_price;
      }
    },

    discount_price_change(index) {
      if (
        this.priceList[index].discount_price > this.priceList[index].sale_price
      ) {
        this.priceList[index].discount_price = this.priceList[index].sale_price;
      }
    },

    closeDialog() {
      this.saveFunding = false;
      this.getOrganisationList();
    },

    addFunding() {
      this.organisationList.push({
        funding_organisation: null,
        copayment_amount_type : "1",
        copayment_amount : null,
        contract_start_date: null,
        contract_end_date: null,
        contract_type: null,
        contract_status: null,
        original_end_date: null,

      });
    },
    openDeleteDialog(index, row) {

      this.removeIndex = index;
      this.removeOrganisation = row;
      this.deleteConfirm = true;
    },

    deleteDialogById(row) {
      this.removeOrganisation = row;
      this.deleteConfirm = true;
    },

    deleteOrganisation() {
      this.organisationList.splice(this.removeIndex, 1);
      this.deleteConfirm = false;
    },

    deleteOrganisationById() {
      this.pageLoading = true;
      const requestUrl = `customer/${this.removeOrganisation?.id}/funding-organisations`;
      this.$store
        .dispatch(DELETE, { url: requestUrl })
        .then(() => {
          SuccessEventBus.$emit(
            "update:success",
            "Success ! Funding Organisation Deleted Successfully."
          );
          this.getOrganisationList();
          this.deleteConfirm = false;
          this.closeDialog();
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => { 
          this.pageLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters(["errors"]),

     filteredContractStatuses() {
      const hasOngoing = this.organisationList.some(
        r => r.contract_status?.toLowerCase().replace(/-/g, '') === 'ongoing'
      );

      return this.contractStatuses.map(s => ({
        ...s,
        disabled: hasOngoing && s.value.toLowerCase().replace(/-/g, '') === 'ongoing'
      }));
    },

    isDisable() {
      const exists = this.organisationList.find((row) => {
        return !row?.funding_group_id;
      });
      return exists ? true : false;
    },
    isStartDateDisable: () => {
      return function (index) {
        if (this.organisationList.length == index + 1) {
          return false;
        }
        return true;
      };
    },
  },
  components: {
    Dialog,
    DatePicker,
    DeleteConfirmTemplate,
    ManageContractStatus,
  },

  mounted() {
    this.getOptions();
    this.getOrganisationList();
  },
};
</script>
